import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import AuthPrivateRoute from '@root/scripts/components/route/AuthPrivateRoute';
import { localUser, isEmpty } from '@util/utils';
import { EMPLOYEE_LOGIN_ROUTER } from '@icoach/router/routerPath';
// mode is exact or strict

const RedirectComponent = (props) => {
    const { ...other } = props;
    return <Redirect {...other} />;
};

const PrivateRoute = ({ as: Component, isAuth = false, ...other }) => {
    const user = localUser.get();
    const employee = localUser.get('employee') || {};

    return (
        <Route
            {...other}
            render={(props) => {
                return user ? (
                    Boolean(user?.isUserAuthorized) ? (
                        isAuth ? (
                            <AuthPrivateRoute {...props} {...other} as={Component} />
                        ) : (
                            <Component {...props} {...other} />
                        )
                    ) : isEmpty(employee) ? (
                        <RedirectComponent to={EMPLOYEE_LOGIN_ROUTER.COACH_LOGIN} />
                    ) : Boolean(employee?.isPasswordResetRequired) ? (
                        <RedirectComponent to={EMPLOYEE_LOGIN_ROUTER.GET_COACH_RESET_PATH(employee.token)} />
                    ) : (
                        isAuth ? (
                            <AuthPrivateRoute {...props} {...other} as={Component} />
                        ) : (
                            <Component {...props} {...other} />
                        )
                    )
                ) : (
                    <RedirectComponent to={EMPLOYEE_LOGIN_ROUTER.BASE} />
                );
            }}
        />
    );
};
export default PrivateRoute;
